// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1ee527a5","468":"b4f00d12"}[chunkId] + ".chunk.js";
};